import { render } from "./PlaylistsAndGroupsModal.vue?vue&type=template&id=9c7b3980&scoped=true"
import script from "./PlaylistsAndGroupsModal.vue?vue&type=script&lang=js"
export * from "./PlaylistsAndGroupsModal.vue?vue&type=script&lang=js"

import "./PlaylistsAndGroupsModal.vue?vue&type=style&index=0&id=9c7b3980&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7b3980"]])

export default __exports__